/**
 * PayMig Brand Theme — SINGLE SOURCE OF TRUTH
 * Derived from "PayMig Brand Guidelines V6.5".
 *
 * Edit brand colors / fonts HERE only. This file is consumed by:
 *   - tailwind.config.js   (brand.* utility classes + font-sans)
 *   - src/index.css        (shadcn CSS variables mirror these values)
 *   - React components      (import { BRAND, FONT_SANS, ROLE_COLORS, ... })
 *
 * Note: public/index.html splash is static HTML and mirrors SPLASH_GRADIENT
 *       manually (keep in sync if you change the teal family below).
 */

// ── Brand colors ────────────────────────────────────────────────
const BRAND = {
  // Teal family
  primary: '#0F766E', // Buttons, headers, links
  primaryLight: '#14B8A6', // Gradients, accents
  primaryDark: '#115E59', // Pressed states
  iconTeal: '#09A7AA', // App icon / tiles / splash bg
  gradientEnd: '#2DD4BF', // Splash gradient stop

  // Accent & semantic
  accent: '#4C49CC', // Accent Purple (logo dot, workspace, owner)
  success: '#059669', // Received, confirmed
  warning: '#D97706', // Pending, caution
  error: '#DC2626', // Failed, destructive
  info: '#2563EB', // Informational

  // Neutrals & surfaces
  ink: '#111827', // textPrimary — headlines, body
  ink2: '#4B5563', // textSecondary — supporting text
  ink3: '#9CA3AF', // textTertiary — hints, timestamps
  surface: '#F3F4F6', // screenBg — app background
  surfaceTeal: '#F0FDFA', // secondaryBg — teal-tinted chips
  border: '#E5E7EB', // card / hairline border
  white: '#FFFFFF',
};

// ── Typography ──────────────────────────────────────────────────
// Native system stack (SF Pro on iOS · Roboto on Android · system-ui on web).
// Brand rule: no custom font files.
const FONT_SANS_STACK = [
  '-apple-system',
  'BlinkMacSystemFont',
  "'SF Pro Text'",
  "'SF Pro'",
  "'Segoe UI'",
  'Roboto',
  "'Helvetica Neue'",
  'Arial',
  'sans-serif',
];
const FONT_SANS = FONT_SANS_STACK.join(', ');

// ── Role colors (Workspace) ─────────────────────────────────────
const ROLE_COLORS = {
  owner: BRAND.accent, // Purple
  admin: BRAND.primary, // Teal
  moderator: BRAND.info, // Blue
  revisor: BRAND.warning, // Yellow
};

// ── Status colors ───────────────────────────────────────────────
const STATUS_COLORS = {
  completed: BRAND.success,
  pending: BRAND.warning,
  failed: BRAND.error,
  info: BRAND.info,
};

// ── Splash gradient (mirrored in public/index.html) ─────────────
const SPLASH_GRADIENT = `linear-gradient(135deg, ${BRAND.primary} 0%, ${BRAND.iconTeal} 25%, ${BRAND.primaryLight} 50%, ${BRAND.gradientEnd} 75%, #5EEAD4 100%)`;

module.exports = { BRAND, FONT_SANS, FONT_SANS_STACK, ROLE_COLORS, STATUS_COLORS, SPLASH_GRADIENT };
